export default "__VITE_ASSET__BbSrod_S__"